import { render, staticRenderFns } from "./IconBookmarkSolid.vue?vue&type=template&id=65ae7aae"
import script from "./IconBookmarkSolid.vue?vue&type=script&lang=js"
export * from "./IconBookmarkSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports